import React, { Component } from 'react'
import { getAttributeCourseStaticInfo, isStudentOnLeave } from '../../helpers/enrolment'
import HECSHelpButton from './FinancialSupport/Buttons/HECSHelpButton'
import FEEHelpButton from './FinancialSupport/Buttons/FEEHelpButton'
import FEEFREEButton from './FinancialSupport/Buttons/FEEFREEButton'
import SAHelpButton from './FinancialSupport/Buttons/SAHelpButton'
import { isElgibleForFundingType, isHelpSubmitted } from '../../helpers/funding'
import FinancialSupportAlertModal from './Modals/FinancialSupportAlertModal'
import { getSoneFundingByCourseSSPNo } from '../../services/vu'
import { getFinanceSupportFormLink } from '../../services/reservoir'
import Loading from './Loading'

class FinanceContainer extends Component {
  constructor(props) {
    super(props)

    this.state = {
      isStudyPlanExpanded: false,
      isFeeHelpSelected: '',
      isFeeFreeSelected: '',
      isSaHelpSelected: '',
      courseLocation: getAttributeCourseStaticInfo('locationCd'),
      modalFeeType: '',
      isModalOpen: false,
      isLoadingNextStep: false,
      isLoadingLinks: true,
      formLinks: [
        { name: 'finance-enquire-link-modal', url: '' },
        { name: 'finance-contact-link-modal', url: '' },
        { name: 'finance-ecaf-form', url: '' },
        { name: 'finance-ssaf-link', url: '' }
      ]
    }
  }

  componentDidMount() {
    let fundingLinks = []

    if (!this.hasNoFundingTypes()) {
      fundingLinks = this.getPropsFundingInfo().potentialFundingType.map(funding => ({
        name: funding.fundingType,
        url: ''
      }))
    }

    this.setState(
      {
        formLinks: [...this.state.formLinks, ...fundingLinks],
        isHecsHelpSelected: isHelpSubmitted('HECS-HELP', this.getPropsFundingInfo()) ? 'Y' : '',
        isFeeHelpSelected: isHelpSubmitted('FEE-HELP', this.getPropsFundingInfo()) ? 'Y' : '',
        isSaHelpSelected: isHelpSubmitted('SA-HELP', this.getPropsFundingInfo()) ? 'Y' : '',
        isFeeFreeSelected: isHelpSubmitted('FEE-FREE', this.getPropsFundingInfo()) ? 'Y' : ''
      },
      this.fetchFinancialLinks
    )
  }

  fetchFinancialLinks = () => {
    let updatedLinks = [...this.state.formLinks]

    updatedLinks.forEach((link, index) => {
      getFinanceSupportFormLink(link.name).then(result => {
        updatedLinks[index] = { ...link, url: result }

        this.setState({
          formLinks: updatedLinks,
          isLoadingLinks: false
        })
      })
    })
  }

  getFundingTypeUrl = name => {
    const link = this.state.formLinks.find(item => item.name === name)
    return link ? link.url : null
  }

  handleNextStep = () => {
    this.setState({ isLoadingNextStep: true })
    Promise.all([
      getSoneFundingByCourseSSPNo(getAttributeCourseStaticInfo('courseSSPNo'), getAttributeCourseStaticInfo('liabilityCategoryCode'), this.props.personalDetails.stuCitizenCd)
    ]).then(([fundingInfo]) => {
      if (isElgibleForFundingType('HECS-HELP', fundingInfo, this.props.personalDetails)) {
        if (isHelpSubmitted('HECS-HELP', fundingInfo)) {
          this.props.successFinish()
        } else {
          this.setState({
            modalFeeType: 'HECS-HELP',
            isModalOpen: true
          })
        }
      } else if (isElgibleForFundingType('FEE-FREE', fundingInfo, this.props.personalDetails)) {
        if (isHelpSubmitted('FEE-FREE', fundingInfo)) {
          this.props.successFinish()
        } else {
          this.setState({
            modalFeeType: 'FEE-FREE Uni Ready',
            isModalOpen: true
          })
        }
      } else {
        this.props.successFinish()
      }
      this.setState({ isLoadingNextStep: false })
    })
  }

  hasNoFundingTypes = () => {
    return this.getPropsFundingInfo().potentialFundingType.length === 0
  }

  handleCloseModal = () => this.setState({ isModalOpen: false })

  getPropsFundingInfo = () => {
    let fundingInfo = this.props.fundingInfo;

    return fundingInfo
  }

  render() {
    if (this.props.fundingApiFailed) {
      return (
        <div className="sidenote sidenote--error">
          <div className="sidenote__content">
            <p>
              There seems to be an issue with your request, please retry. Please{' '}
              <a href="https://www.vu.edu.au/contact-us" target="_blank">
                contact VUHQ
              </a>{' '}
              if you require assistance.
            </p>
          </div>
        </div>
      )
    }

    if (isStudentOnLeave()) {
      return (
        <div className="sidenote sidenote--error">
          <div className="sidenote__content">
            <p>
              You have a current Leave of Absence record for this course, changes cannot be made to your enrolment during this time. Please{' '}
              <a href="https://www.vu.edu.au/contact-us" target="_blank">
                contact VUHQ
              </a>{' '}
              if you require assistance.
            </p>
          </div>
        </div>
      )
    }

    if (this.hasNoFundingTypes()) {
      return (
        <div className="sidenote sidenote--fyi">
          <div className="sidenote__content center-xs">
            <p>
              <strong>
                You are currently not eligible for financial support. Please <a href="https://www.vu.edu.au/contact-us/vuhq-student-service-centres">contact VUHQ</a> if you require further
                information.
              </strong>
            </p>
          </div>
        </div>
      )
    }

    if (!this.props.isStudyPlanExpanded) {
      return (
        <div className="sidenote sidenote--error">
          <div className="sidenote__content">
            <p>
              Your study plan is not ready for enrolment. Please{' '}
              <a href="https://www.vu.edu.au/contact-us" target="_blank">
                contact VUHQ
              </a>{' '}
              to discuss your enrolment.
            </p>
          </div>
        </div>
      )
    }

    return this.state.isLoadingLinks ? (
      <Loading />
    ) : (
      <div>
        <HECSHelpButton
          updateHelpPreference={this.updateHelpPreference}
          isHelpSubmitted={isHelpSubmitted('HECS-HELP', this.getPropsFundingInfo()) ? 'Y' : 'N'}
          ineligibleForHECSHelpInd={isElgibleForFundingType('HECS-HELP', this.getPropsFundingInfo(), this.props.personalDetails) ? 'N' : 'Y'}
          citizenCode={this.props.personalDetails.stuCitizenCd}
          link={this.getFundingTypeUrl('HECS-HELP')}
          ecafLink={this.getFundingTypeUrl('finance-ecaf-form')}
        />

        <FEEHelpButton
          handleInputChange={this.handleInputChange}
          isHelpSubmitted={isHelpSubmitted('FEE-HELP', this.getPropsFundingInfo()) ? 'Y' : 'N'}
          isHelpSelected={this.state.isFeeHelpSelected}
          ineligibleForFEEHelpInd={isElgibleForFundingType('FEE-HELP', this.getPropsFundingInfo(), this.props.personalDetails) ? 'N' : 'Y'}
          link={this.getFundingTypeUrl('FEE-HELP')}
        />

        <FEEFREEButton
          handleInputChange={this.handleInputChange}
          isHelpSubmitted={isHelpSubmitted('FEE-FREE', this.getPropsFundingInfo()) ? 'Y' : 'N'}
          isHelpSelected={this.state.isFeeFreeSelected}
          ineligibleForFEEFREEInd={isElgibleForFundingType('FEE-FREE', this.getPropsFundingInfo(), this.props.personalDetails) ? 'N' : 'Y'}
          link={this.getFundingTypeUrl('FEE-FREE')}
        />

        {this.state.courseLocation !== 'ZV' && (
          <SAHelpButton
            updateHelpPreference={this.updateHelpPreference}
            isHelpSubmitted={isHelpSubmitted('SA-HELP', this.getPropsFundingInfo()) ? 'Y' : 'N'}
            isHelpSelected={this.state.isSaHelpSelected}
            ineligibleForSAHelpInd={isElgibleForFundingType('SA-HELP', this.getPropsFundingInfo(), this.props.personalDetails) ? 'N' : 'Y'}
            link={this.getFundingTypeUrl('SA-HELP')}
            ssafLink={this.getFundingTypeUrl('finance-ssaf-link')}
          />
        )}

        {this.props.isAbleToEdit && (
          <div className="row">
            <div className="col-xs-12 col-md-3">
              <a className={`btn btn-md btn-primary center ${this.state.isLoadingNextStep ? 'disabled-link' : ''}`} style={{ padding: '1rem 0rem' }} onClick={this.handleNextStep}>
                Continue
              </a>
            </div>
          </div>
        )}

        <FinancialSupportAlertModal
          className="modal-lg"
          feeType = {this.state.modalFeeType}
          isOpen={this.state.isModalOpen}
          handleCloseModal={this.handleCloseModal}
          enquireLink={this.getFundingTypeUrl('finance-enquire-link-modal') || ''}
          contactLink={this.getFundingTypeUrl('finance-contact-link-modal') || ''}
        />
      </div>
    )
  }
}

export default FinanceContainer
